import { Routes } from '@angular/router';
import { langMatch, langSyncGuard } from './core/guards/lang.guard';
import { PATHS } from './core/routing/localized-routes';

const homePage = () => import('./pages/home/home').then((m) => m.HomePage);
const programsPage = () => import('./pages/programs/programs').then((m) => m.ProgramsPage);
const programDetailPage = () => import('./pages/programs/program-detail/program-detail').then((m) => m.ProgramDetailPage);
const degreeRecognitionPage = () => import('./pages/degree-recognition/degree-recognition').then((m) => m.DegreeRecognitionPage);
const aboutPage = () => import('./pages/about/about').then((m) => m.AboutPage);
const termsOfUsePage = () => import('./pages/legal/terms-of-use/terms-of-use').then((m) => m.TermOfUsePage);
const termsOfSalePage = () => import('./pages/legal/terms-of-sale/terms-of-sale').then((m) => m.TermsOfSalePage);
const legalNoticePage = () => import('./pages/legal/legal-notice/legal-notice').then((m) => m.LegalNoticePage);
const privacyPolicyPage = () => import('./pages/legal/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicyPage);
const cookiePolicyPage = () => import('./pages/legal/cookie-policy/cookie-policy').then((m) => m.CookiePolicyPage);
const refundPolicyPage = () => import('./pages/legal/refund-policy/refund-policy').then((m) => m.RefundPolicyPage);

export const routes: Routes = [
  {
    path: ':lang',
    canMatch: [langMatch],
    canActivate: [langSyncGuard],
    children: [
      { path: '', pathMatch: 'full', loadComponent: homePage },
      { path: PATHS.programs.fr, loadComponent: programsPage },
      { path: `${PATHS.programs.fr}/:id`, loadComponent: programDetailPage },
      { path: PATHS.programs.en, loadComponent: programsPage },
      { path: `${PATHS.programs.en}/:id`, loadComponent: programDetailPage },
      { path: PATHS.degreeRecognition.fr, loadComponent: degreeRecognitionPage },
      { path: PATHS.degreeRecognition.en, loadComponent: degreeRecognitionPage },
      { path: PATHS.about.fr, loadComponent: aboutPage },
      { path: PATHS.about.en, loadComponent: aboutPage },
      { path: PATHS.terms.fr, loadComponent: termsOfUsePage },
      { path: PATHS.terms.en, loadComponent: termsOfUsePage },
      { path: PATHS.termsOfSale.fr, loadComponent: termsOfSalePage },
      { path: PATHS.termsOfSale.en, loadComponent: termsOfSalePage },
      { path: PATHS.legalNotice.fr, loadComponent: legalNoticePage },
      { path: PATHS.legalNotice.en, loadComponent: legalNoticePage },
      { path: PATHS.privacy.fr, loadComponent: privacyPolicyPage },
      { path: PATHS.privacy.en, loadComponent: privacyPolicyPage },
      { path: PATHS.cookiePolicy.fr, loadComponent: cookiePolicyPage },
      { path: PATHS.cookiePolicy.en, loadComponent: cookiePolicyPage },
      { path: PATHS.refundPolicy.fr, loadComponent: refundPolicyPage },
      { path: PATHS.refundPolicy.en, loadComponent: refundPolicyPage },
      // Legacy path segments under :lang
      { path: 'universites', redirectTo: '' },
      { path: 'universites-partenaires', redirectTo: '' },
      { path: 'universities', redirectTo: '' },
      { path: 'partner-universities', redirectTo: '' },
      { path: 'reconnaissance-diplomes', redirectTo: PATHS.degreeRecognition.fr },
      { path: 'conditions-generales-dutilisation', redirectTo: PATHS.terms.fr },
      { path: 'conditions-generales-d-utilisation', redirectTo: PATHS.terms.fr },
      { path: 'conditions-generales-utilisation', redirectTo: PATHS.terms.fr },
      { path: 'conditions-generales-de-vente', redirectTo: PATHS.termsOfSale.fr },
      { path: 'conditions-generales-vente', redirectTo: PATHS.termsOfSale.fr },
      { path: 'confidentialite', redirectTo: PATHS.privacy.fr },
      { path: 'politique-de-cookies', redirectTo: PATHS.cookiePolicy.fr },
      { path: 'cookies', redirectTo: PATHS.cookiePolicy.fr },
      { path: 'remboursement', redirectTo: PATHS.refundPolicy.fr },
      { path: 'politique-remboursement', redirectTo: PATHS.refundPolicy.fr },
      { path: '**', redirectTo: '' },
    ],
  },

  // Legacy FR URLs without lang prefix
  { path: 'formations', redirectTo: '/fr/formations' },
  { path: 'universites', redirectTo: '/fr' },
  { path: 'universites-partenaires', redirectTo: '/fr' },
  { path: 'reconnaissance-diplomes', redirectTo: `/fr/${PATHS.degreeRecognition.fr}` },
  { path: 'reconnaissance-des-diplomes', redirectTo: `/fr/${PATHS.degreeRecognition.fr}` },
  { path: 'a-propos', redirectTo: '/fr/a-propos' },
  { path: 'cgu', redirectTo: `/fr/${PATHS.terms.fr}` },
  { path: 'conditions-generales-dutilisation', redirectTo: `/fr/${PATHS.terms.fr}` },
  { path: 'conditions-generales-d-utilisation', redirectTo: `/fr/${PATHS.terms.fr}` },
  { path: 'conditions-generales-utilisation', redirectTo: `/fr/${PATHS.terms.fr}` },
  { path: 'cgv', redirectTo: `/fr/${PATHS.termsOfSale.fr}` },
  { path: 'conditions-generales-de-vente', redirectTo: `/fr/${PATHS.termsOfSale.fr}` },
  { path: 'conditions-generales-vente', redirectTo: `/fr/${PATHS.termsOfSale.fr}` },
  { path: 'mentions-legales', redirectTo: '/fr/mentions-legales' },
  { path: 'confidentialite', redirectTo: `/fr/${PATHS.privacy.fr}` },
  { path: 'politique-de-confidentialite', redirectTo: `/fr/${PATHS.privacy.fr}` },
  { path: 'politique-cookies', redirectTo: `/fr/${PATHS.cookiePolicy.fr}` },
  { path: 'politique-de-cookies', redirectTo: `/fr/${PATHS.cookiePolicy.fr}` },
  { path: 'cookies', redirectTo: `/fr/${PATHS.cookiePolicy.fr}` },
  { path: 'politique-de-remboursement', redirectTo: `/fr/${PATHS.refundPolicy.fr}` },
  { path: 'remboursement', redirectTo: `/fr/${PATHS.refundPolicy.fr}` },
  { path: 'politique-remboursement', redirectTo: `/fr/${PATHS.refundPolicy.fr}` },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      const stored = localStorage.getItem('lang');
      return stored === 'en' ? '/en' : '/fr';
    },
  },
  { path: '**', redirectTo: '/fr' },
];
